import { learningApi } from 'services/api'

export const DELETE_QUESTION_BOOK_ITEM = async (questionBookId: string, itemId: string) => {
  try {
    const token = localStorage.getItem('token')

    await learningApi.delete(`/question/books/${questionBookId}/items/${itemId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const GET_UNANSWERED_PAGE = async (
  bookId: string,
  mostRecent: boolean,
  itemsPerPage: number
) => {
  try {
    const token = localStorage.getItem('token')

    const { data } = await learningApi.get<{ unansweredIndex: number; unansweredPage: number }>(
      `/question/books/${bookId}/items/unanswered?mostRecent=${mostRecent}&limit=${itemsPerPage}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return data
  } catch (err) {
    console.log(err)
    throw err
  }
}
